export default [
  {
    path: '/work/outCustomerRecordDetail/list',
    meta: {},
    component: (resolve) => require(['./List.vue'], resolve),
  },
]



// WEBPACK FOOTER //
// ./src/modules/work/outCustomerRecordDetail/router.js